import _ from 'underscore'
var $ = window.jQuery;
import Vue from 'vue'

import BaseComponent from '@base/component'

var DoubleProteinVue = Vue.extend({
    mixins: [ BaseComponent ],
    props: ['mdl'],
    data: function() {
	$("#pa_protein").change((evt:any) => (this as InstanceType<typeof DoubleProteinVue>).chooseProduct(evt));
        
        return {
            id: "",
            model: this.mdl
        };
    },
    methods: {
        chooseProduct: function(evt:any) {
	    var sel = $("#pa_protein");
	    var id = sel.val();
	    console.log("chooseProduct",id);
	    this.id = id;
	    var vars = $("form[data-product_id]").data("product_variations");
	    var prodid = null;
	    _.each(vars, function(v) {
	        if (v.attributes && v.attributes.attribute_pa_protein && v.attributes.attribute_pa_protein == id)
		    prodid = v.variation_id;
	    });
	    
	    var data:any = {id: prodid, action:"nutrition_model"};
	    data.label = this.model.get("label");
	    data.protein = id;
	    $.ajax({url:'/wp-admin/admin-ajax.php', data: data, success: (mdl:any) => this.chooseProductDone(mdl), error: (xhr:any, status:string) => this.failureFn(xhr, status), dataType: "json"});
        },
        failureFn: function(xhr:XMLHttpRequest, status:string) {
	    console.error("failureFn ",arguments);
        },
        chooseProductDone: function(mdl:any) {
	    mdl.itemName.show = false;
	    mdl.disclaimer.show = false;
	    mdl.ingredientList.show = false;
	    
	    this.model.set(mdl, {parse:true});
        }
    }
});
export default DoubleProteinVue;
